/* istanbul ignore file */
export * from './DeepQueryHint';
